
import { defineComponent, computed, ref } from '@nuxtjs/composition-api';
import CatalogFilterItem from '@/domains/catalog/components/CatalogFilterItem.vue';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';

const MAX_ITEMS = 5;

export default defineComponent({
  components: { CatalogFilterItem },
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { isGreater } = useBreakpoints(breakpointsTailwind);
    const isDesktop = isGreater('lg');

    const isCollapsed = ref(true);
    const filterChanges = ref();

    const valueLocal = computed({
      get() {
        return props.value;
      },
      set(newValue) {
        if (!props.disabled) emit('input', newValue);
      },
    });

    const shouldCollapsed = computed(() => props.filters.length > MAX_ITEMS);
    const localFilters = computed(() => {
      if (shouldCollapsed.value && isCollapsed.value)
        return props.filters.slice(0, MAX_ITEMS);
      return props.filters;
    });
    const collapsedCount = computed(() => props.filters.length - MAX_ITEMS);

    const isFeatureFilter = (filter) => {
      return typeof filter.id !== 'string';
    };

    const toggleCollapse = () => {
      isCollapsed.value = !isCollapsed.value;
    };

    return {
      isDesktop,
      valueLocal,
      isCollapsed,
      filterChanges,
      localFilters,
      collapsedCount,
      shouldCollapsed,
      isFeatureFilter,
      toggleCollapse,
    };
  },
});
